import React from "react";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
  },
}));

interface NumberFormatCustomProps {
  onChange: (event: { target: { value: string } }) => void;
  [key: string]: any;
}

const NumberFormatCustom = React.forwardRef<
  HTMLInputElement,
  NumberFormatCustomProps
>(function NumberFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      // MUI entrega la referencia al input como `ref`, no como prop.
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      //   thousandSeparator={"."}
      //   decimalSeparator={","}
      isNumericString
      //   prefix="$"
      decimalScale={0}
    />
  );
});

NumberFormatCustom.propTypes = {
  onChange: PropTypes.func.isRequired,
};

interface IntegerInputFieldProps {
  // Recibe el evento del TextField o el objeto sintético que arma NumberFormat
  onChange?: (event: { target: { value: string } } | any) => void;
  value?: string | number | null;
  className?: string;
  label?: React.ReactNode;
  inputProps?: Record<string, any>;
  id?: string;
  required?: boolean;
  hasError?: boolean;
  helperText?: React.ReactNode;
  reference?: React.Ref<HTMLInputElement>;
  onBlur?: () => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  variant?: "standard" | "outlined" | "filled";
  placeholder?: string;
}

const IntegerInputField: React.FC<IntegerInputFieldProps> = ({
  onChange,
  value,
  className,
  label,
  inputProps,
  id,
  required,
  hasError,
  helperText,
  reference,
  onBlur,
  onKeyDown,
  variant,
  placeholder,
}) => {
  const classes = useStyles();

  const handleChange = (val: any) => {
    if (onChange) onChange(val);
  };

  const handleBlur = () => {
    if (onBlur) onBlur();
  };

  return (
    <div className={classes.container}>
      <TextField
        className={classes.container}
        label={label}
        value={value}
        onChange={(event) => handleChange(event)}
        onBlur={handleBlur}
        id={id}
        InputProps={{
          inputComponent: NumberFormatCustom as any,
          inputProps,
        }}
        variant={variant}
        error={hasError}
        helperText={helperText}
        inputRef={reference}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
      />
    </div>
  );
};

export default IntegerInputField;
